export const CONFIG = 'CONFIG'

export const COLLAPSE_MENU = 'COLLAPSE_MENU'

export const AUTH_USER = 'AUTH_USER'
export const AUTH_PERMISSIONS = 'AUTH_PERMISSIONS'
export const AUTH_ROLES = 'AUTH_ROLES'
export const AUTH_TOKEN = 'AUTH_TOKEN'

export const LOADER_SHOW = 'LOADER_SHOW'

export const LIST_INIT = 'LIST_INIT'
export const LIST_ORIGINAL_DATA = 'LIST_ORIGINAL_DATA'
export const LIST_DATA = 'LIST_DATA'
export const LIST_TOTAL = 'LIST_TOTAL'
export const LIST_PER_PAGE = 'LIST_PER_PAGE'
export const LIST_CURRENT_PAGE = 'LIST_CURRENT_PAGE'
export const LIST_FILTERS = 'LIST_FILTERS'



// WEBPACK FOOTER //
// ./src/vuex/types.js